// Customer.jsx
import React from 'react';

import { Paper } from '@mantine/core';
import SalespersonTabSet from './SalespersonTabSet';
 
const Salesperson = () => {
    return (
        <Paper>
            <SalespersonTabSet />
        </Paper>
    );
};

export default Salesperson;
